module.exports = __webpack_public_path__ + "static/img/notice.a6b6b6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/notice.png
// module id = z+t5
// module chunks = 1